export type Benefit = { title: string; text: string }

// "Waarom het goed voor je is" — per product drie concrete voordelen.
export const productBenefits: Record<string, Benefit[]> = {
  'hammam-ritueel-set': [
    { title: 'Alles in één keer', text: 'Vijf producten die op elkaar zijn afgestemd. Je hoeft niets uit te zoeken: open de doos en begin.' },
    { title: 'Zachtere huid vanaf de eerste keer', text: 'Reinigen, scrubben en voeden in de juiste volgorde laat de huid direct merkbaar gladder en soepeler aanvoelen.' },
    { title: 'Voordeliger dan los', text: 'Je bespaart ten opzichte van de losse producten — en het is meteen een stijlvol cadeau.' },
  ],
  arganolie: [
    { title: 'Voedt zonder vet te voelen', text: 'Trekt snel in en laat de huid soepel aanvoelen, zonder plakkerige laag.' },
    { title: 'Eén olie voor alles', text: 'Te gebruiken op gezicht, lichaam, haarpunten en baard. Minder potjes, meer verzorging.' },
    { title: 'Van nature rijk aan vitamine E', text: 'Tocoferolen zijn antioxidanten die de huid helpen beschermen tegen invloeden van buitenaf.' },
  ],
  'savon-beldi': [
    { title: 'Grondig én zacht', text: 'De olijfbasis reinigt de huid diep, zonder dat het ruw of trekkerig aanvoelt.' },
    { title: 'Maakt scrubben effectiever', text: 'Verzacht de bovenste huidlaag, zodat de kessa dode huidcellen moeiteloos verwijdert.' },
    { title: 'Puur en herkenbaar', text: 'Een traditioneel product met een korte, eerlijke samenstelling — zoals het al eeuwen wordt gemaakt.' },
  ],
  kessa: [
    { title: 'Direct voelbaar gladder', text: 'Na één keer scrubben voelt je huid zichtbaar zachter en egaler aan.' },
    { title: 'Minder ingegroeide haartjes', text: 'Regelmatig exfoliëren houdt de haarzakjes vrij en helpt ingegroeide haartjes voorkomen.' },
    { title: 'Je verzorging werkt beter', text: 'Na het scrubben neemt de huid olie en verzorging veel beter op.' },
  ],
  ghassoul: [
    { title: 'Reinigt zonder uit te drogen', text: 'Haalt vuil en onzuiverheden weg, terwijl de huid zacht en comfortabel blijft.' },
    { title: 'Ideaal bij een vette of onzuivere huid', text: 'Absorbeert overtollig talg, zodat de huid er frisser en matter uitziet.' },
    { title: 'Voor huid én haar', text: 'Ook te gebruiken als milde haarwas voor een schone hoofdhuid en luchtig haar.' },
  ],
  rozenwater: [
    { title: 'Verfrist op elk moment', text: 'Een paar sprays geven direct een frisse, lichte huid — ook handig overdag.' },
    { title: 'Zacht voor de huid', text: 'Voelt verzachtend aan en is prettig voor ook de gevoelige huid.' },
    { title: 'Bereidt voor op verzorging', text: 'Een vochtige huid neemt olie of crème beter op. Rozenwater is de perfecte tussenstap.' },
  ],
  cactusvijgolie: [
    { title: 'Voor de droge, trekkerige huid', text: 'Geeft direct comfort en laat de huid weer soepel aanvoelen.' },
    { title: 'Licht en snel intrekkend', text: 'Ideaal onder make-up of als avondverzorging, zonder glimmend resultaat.' },
    { title: 'Ondersteunt de huidbarrière', text: 'Het hoge gehalte linolzuur helpt de huid vocht vast te houden.' },
  ],
  nila: [
    { title: 'Frisse, egale uitstraling', text: 'Een traditioneel masker dat de huid helder en verzorgd laat ogen.' },
    { title: 'Schoonheidsgeheim uit de Sahara', text: 'Al generaties gebruikt door vrouwen in de woestijn voor een stralende huid.' },
    { title: 'Mild masker', text: 'Zacht voor de huid, zonder schuren of prikken.' },
  ],
  tbrima: [
    { title: 'Verzorgende kruidenmix', text: 'Ons eigen mengsel van fijngemalen planten voor een complete bodytreatment.' },
    { title: 'Zacht en geurig', text: 'Laat de huid zacht aanvoelen met een subtiele, natuurlijke kruidengeur.' },
    { title: 'Makkelijk te combineren', text: 'Meng met rozenwater of ghassoul voor jouw eigen verzorgende pasta.' },
  ],
  oranjebloesemwater: [
    { title: 'Frisse start van je dag', text: 'Een lichte mist die de huid direct wakker en fris laat aanvoelen.' },
    { title: 'Ideaal na het scheren', text: 'Verkoelt en verfrist de huid, zonder vettig of plakkerig gevoel.' },
    { title: 'Rustgevende geur', text: 'Oranjebloesem staat bekend om zijn zachte, kalmerende geur.' },
  ],
  musk: [
    { title: 'Zacht en langdurig', text: 'Een warme geur die subtiel blijft hangen en de hele dag meegaat.' },
    { title: 'Prettig op de huid', text: 'Als geurolie droogt hij de huid niet uit zoals veel parfums met alcohol.' },
    { title: 'Klein formaat, groot effect', text: 'Een kleine hoeveelheid is genoeg. Een flesje gaat lang mee.' },
  ],
  oud: [
    { title: 'Diep en uitgesproken', text: 'Een rijke, houtachtige geur met karakter — voor wie opvalt zonder te overheersen.' },
    { title: 'Houdt lang aan', text: 'Ontwikkelt zich geleidelijk en blijft urenlang op de huid.' },
    { title: 'Perfect te combineren', text: 'Laag hem over Musk voor een warme, persoonlijke signatuurgeur.' },
  ],
  'geurset-musk-oud': [
    { title: 'Twee geuren, één cadeau', text: 'Zacht en diep in één set — altijd een geur die past bij het moment.' },
    { title: 'Voor dag én avond', text: 'Musk voor overdag, Oud voor de avond. Of combineer ze voor iets eigens.' },
    { title: 'Direct cadeauklaar', text: 'Stijlvol verpakt, inclusief een gratis kaartje met jouw persoonlijke boodschap.' },
  ],
  'henna-sidr': [
    { title: 'Natuurlijke kleur en glans', text: 'Geeft het haar een warme hennatint en een gezonde glans.' },
    { title: 'Voller aanvoelend haar', text: 'Henna legt zich om de haarschacht, waardoor het haar steviger en voller aanvoelt.' },
    { title: 'Plantaardig', text: 'Op basis van poeders van henna- en sidrbladeren, zonder synthetische kleurstoffen.' },
  ],
  rozenblaadjes: [
    { title: 'Een spa-moment thuis', text: 'Een handvol in warm badwater maakt van elk bad een moment voor jezelf.' },
    { title: 'Verrijkt je masker', text: 'Fijngemalen door ghassoul voor een verzorgend en geurig gezichtsmasker.' },
    { title: 'Natuurlijke antioxidanten', text: 'Rijk aan polyfenolen en flavonoïden uit de Damascusroos.' },
  ],
  kohl: [
    { title: 'Intense, diepe oogopslag', text: 'Accentueert je ogen met een rijke, donkere lijn.' },
    { title: 'Traditioneel en natuurlijk', text: 'Een eeuwenoude eyeliner op basis van natuurlijke ingrediënten.' },
    { title: 'Makkelijk aan te brengen', text: 'Met het stokje trek je in één beweging een zachte, egale lijn.' },
  ],
  'aker-fassi': [
    { title: 'Een natuurlijke blos', text: 'Geeft wangen en lippen een frisse, gezonde kleur.' },
    { title: 'Twee in één', text: 'Te gebruiken als blush én als lipkleur — handig voor onderweg.' },
    { title: 'Opbouwbaar', text: 'Van subtiel tot uitgesproken: jij bepaalt de intensiteit.' },
  ],
  mhekka: [
    { title: 'Zachte voeten', text: 'Verwijdert eelt en ruwe plekken voor gladde hielen en voeten.' },
    { title: 'Gaat lang mee', text: 'Van natuurlijk terracotta: stevig, hygiënisch en jarenlang bruikbaar.' },
    { title: 'Verzorging werkt beter', text: 'Na gebruik nemen olie en voetcrème veel beter op.' },
  ],

  // AMIRA Living
  'khamsa-ketting': [
    { title: 'Betekenisvol', text: 'De khamsa staat in Marokko voor bescherming en geluk — een sieraad met een verhaal.' },
    { title: 'Elke dag te dragen', text: 'Fijn en licht, mooi alleen of gecombineerd met andere kettingen.' },
    { title: 'Klaar om te geven', text: 'Geleverd in een katoenen zakje, inclusief gratis kaartje.' },
  ],
  'berber-armband': [
    { title: 'Echt handwerk', text: 'Elk patroon is met de hand gegraveerd, dus elke armband is net even anders.' },
    { title: 'Maakt je look af', text: 'Eén statement-stuk is genoeg om een eenvoudige outfit bijzonder te maken.' },
    { title: 'Goede pasvorm', text: 'Licht buigbaar, zodat hij comfortabel om je pols sluit.' },
  ],
  'fibula-oorbellen': [
    { title: 'Erfgoed om te dragen', text: 'Geïnspireerd op de mantelspeld die Berbervrouwen al eeuwen dragen.' },
    { title: 'Kleur zonder drukte', text: 'Subtiele emaildetails in koraal en groen.' },
    { title: 'Licht aan het oor', text: 'Comfortabel, ook als je ze de hele dag draagt.' },
  ],
  'amazigh-ring': [
    { title: 'Uitgesproken', text: 'Een ring die opvalt, met kleuren uit de Amazigh-traditie.' },
    { title: 'In drie maten', text: 'Kies maat 16, 17 of 18 voor de juiste pasvorm.' },
    { title: 'Combineert makkelijk', text: 'Mooi bij zilveren armbanden en de khamsa ketting.' },
  ],
  'safi-dinerbord': [
    { title: 'Uniek aan tafel', text: 'Met de hand beschilderd — geen twee borden zijn hetzelfde.' },
    { title: 'Voor elke dag', text: 'Stevig aardewerk met voedselveilig glazuur, gewoon voor dagelijks gebruik.' },
    { title: 'Voordelig als set', text: 'De set van 4 is voordeliger dan los kopen.' },
  ],
  'fes-serveerschaal': [
    { title: 'Middelpunt van je tafel', text: 'Groot genoeg voor couscous of salade voor het hele gezelschap.' },
    { title: 'Klassiek Fès-motief', text: 'Het beroemde kobaltblauw past bij elk servies.' },
    { title: 'Ook als decoratie', text: 'Met fruit op tafel is hij net zo mooi als aan het diner.' },
  ],
  serveertajine: [
    { title: 'Sfeervol serveren', text: 'Zet je gerecht op tafel zoals het in Marokko hoort.' },
    { title: 'Houdt warm', text: 'Het deksel houdt je gerecht langer op temperatuur.' },
    { title: 'Twee formaten', text: 'Kies Ø 25 cm voor twee personen of Ø 30 cm voor het gezin.' },
  ],
  'zellige-schaaltjes': [
    { title: 'Kleur op tafel', text: 'Zes kleuren uit het zellige-tegelwerk in één set.' },
    { title: 'Veelzijdig', text: 'Voor olijven, dips, kruiden of sieraden op je nachtkastje.' },
    { title: 'Makkelijk schoon', text: 'Vaatwasserbestendig op een laag programma.' },
  ],
  'beldi-theeglazen': [
    { title: 'De echte muntthee-beleving', text: 'Precies het formaat en de vorm van de glazen in elk Marokkaans huis.' },
    { title: 'Feestelijk decor', text: 'Het gouddecor maakt elk theemoment bijzonder.' },
    { title: 'Ook als cadeau', text: 'Een geliefd cadeau voor housewarmings en Ramadan.' },
  ],
  'handgeblazen-glazen': [
    { title: 'Duurzaam', text: 'Gemaakt van gerecycled glas door glasblazers in Marrakech.' },
    { title: 'Uniek karakter', text: 'Luchtbelletjes en kleine vormverschillen maken elk glas anders.' },
    { title: 'Dagelijks bruikbaar', text: 'Stevig en vaatwasserbestendig.' },
  ],
  'safi-espressokopjes': [
    { title: 'Kleine luxe', text: 'Maak van je dagelijkse espresso een moment.' },
    { title: 'Handbeschilderd', text: 'Kobaltblauw patroon uit de pottenbakkerijen van Safi.' },
    { title: 'Perfect cadeau', text: 'Een set van twee — om te delen.' },
  ],
  'marokkaanse-theepot': [
    { title: 'Schenk zoals het hoort', text: 'De lange tuit maakt hoog schenken makkelijk, voor het typische schuimlaagje.' },
    { title: 'Op het vuur te gebruiken', text: 'Geschikt voor gas en keramische kookplaat.' },
    { title: 'Twee formaten', text: '0,8 liter voor vier glazen, 1,2 liter voor het hele gezelschap.' },
  ],
  'thee-ceremonie-set': [
    { title: 'Alles in één keer', text: 'Theepot, zes glazen en dienblad die bij elkaar horen.' },
    { title: 'Voordeliger dan los', text: 'Je bespaart ten opzichte van de losse producten.' },
    { title: 'Het ultieme cadeau', text: 'Stijlvol verpakt — ideaal voor een housewarming of bruiloft.' },
  ],
  'koperen-lantaarn': [
    { title: 'Sfeer in één keer', text: 'Het sterrenpatroon tovert een warm lichtspel op je muren.' },
    { title: 'Binnen en buiten', text: 'Mooi in de woonkamer, op het terras of op tafel.' },
    { title: 'Met de hand geponst', text: 'Elk patroon is met de hand in het messing geslagen.' },
  ],
  'kilim-kussenhoes': [
    { title: 'Warmte in huis', text: 'Berber-motieven geven je bank of bed direct karakter.' },
    { title: 'Handgeweven', text: 'Van wol en katoen, met zichtbaar vakmanschap.' },
    { title: 'Makkelijk te wisselen', text: 'Met rits — past om elk standaard 45 × 45 binnenkussen.' },
  ],
}
